// @ts-nocheck

export default {
  setExternalRequest ({ commit }, externalRequest) {
    commit('SET_EXTERNAL_REQUEST', externalRequest)
  }
}
